const transformAccessoriesResponse = (response) => response.map(item => {
    var _a, _b, _c, _d, _e, _f, _g;
    return ({
        id: item.AccessoryId,
        key: item.AccessoryKey,
        businessKey: item.AccessoryBusinessKey,
        category: {
            id: item.AccessoryCategory.Key,
            name: item.AccessoryCategory.Name,
            displayOrder: item.AccessoryCategory.DisplayOrder,
            gtmName: (_a = item.AccessoryCategory) === null || _a === void 0 ? void 0 : _a.GtmName,
        },
        subCategory: {
            id: (_b = item.AccessorySubCategory) === null || _b === void 0 ? void 0 : _b.Key,
            name: (_c = item.AccessorySubCategory) === null || _c === void 0 ? void 0 : _c.Name,
            displayOrder: (_d = item.AccessorySubCategory) === null || _d === void 0 ? void 0 : _d.DisplayOrder,
            gtmName: (_e = item.AccessorySubCategory) === null || _e === void 0 ? void 0 : _e.GtmName,
        },
        name: item.AccessoryName,
        accessoryGtmName: item.AccessoryGtmName,
        description: item.AccessoryDescription,
        listPrice: item.AccessoryListPrice,
        payment: 0,
        provincialPrice: item.AccessoryProvincialPrice,
        defaultThumbnailAssetUrl: item.DefaultThumbnailAssetUrl,
        thumbnailAssetUrl: item.ThumbnailAssetUrl,
        additionalThumbnailAssetUrls: [item.ThumbnailAssetUrl, item === null || item === void 0 ? void 0 : item.Thumbnail2AssetUrl, item === null || item === void 0 ? void 0 : item.Thumbnail3AssetUrl].filter(url => url != null),
        accessoryDisplayOrder: item.AccessoryDisplayOrder,
        overlayAssets: (_f = item === null || item === void 0 ? void 0 : item.OverlayAssetUrls) === null || _f === void 0 ? void 0 : _f.map(url => ({
            src: url,
            alt: item === null || item === void 0 ? void 0 : item.AccessoryName,
        })),
        hasOverlayAssets: ((_g = item === null || item === void 0 ? void 0 : item.OverlayAssetUrls) === null || _g === void 0 ? void 0 : _g.length) > 0,
        isFeatured: item.AccessoryIsFeatured,
        isIncluded: item.AccessoryIsIncluded,
        exclusions: item.Exclusions,
        dependencies: item.Dependencies,
        isSelected: false,
    });
});
export default transformAccessoriesResponse;
